import React, { useRef, useState } from "react"
import { Icon, PickerModal, Text } from "@components"
import { StyleSheet, TouchableOpacity } from "react-native"
import { SelectionItem } from "@utils"
import { useTheme } from "@react-navigation/native"
import { Theme } from "@theme"
import { View } from "react-native"
import { useScreen } from "@hooks"
import { useLanguage } from "@context"

const getFilters = (t: (key: string) => string) => [
    { name: t('common.momentFilterAll'), id: 'default' },
    { name: t('common.momentFilterToday'), id: 'today' },
    { name: t('common.momentFilterWeek'), id: 'week' },
    { name: t('common.momentFilterMonth'), id: 'month' },
    { name: t('common.momentFilterLater'), id: 'later' },
]

export const getMomentFilterMap = (t: (key: string) => string): Record<string, string> => ({
    today: t('common.momentFilterToday'),
    week: t('common.momentFilterWeek'),
    month: t('common.momentFilterMonth'),
    later: t('common.momentFilterLater'),
})

export const MomentFilter = ({filter, setFilter} : {filter: SelectionItem, setFilter: (filter: SelectionItem) => void}) => {
    const theme = useTheme()
    const styles = getStyle(theme)
    const {isDesktop} = useScreen()
    const { t } = useLanguage()
    const buttonRef = useRef<TouchableOpacity>(null);
    const filters = getFilters(t)

    const [isFilter, setIsFilter] = useState<{x: number, y: number}>()
    const isActive = filter.id !== 'default'

    return(
        <View>
            <TouchableOpacity ref={buttonRef} onPress={() => {
                  buttonRef.current?.measure((x, y, width, height, pageX, pageY) => {
                    setIsFilter({x: pageX, y: pageY + height + 5})
                  })
            }} style={styles.filter}>
                <Icon name='filter2' size={16} color={isActive? theme.colors.primary : theme.colors.greyBlue}/>
                <Text type={isActive? "bodySmallBold" : "bodySmall"} color={isActive? theme.colors.primary : theme.colors.greyBlue}>{isActive? filter.name : t('common.filter')}</Text>
                <Icon name='arrowDown' size={16} color={theme.colors.secondary}/>
            </TouchableOpacity>
            <PickerModal isVisible={isFilter !== undefined} position={isDesktop? isFilter : undefined} setIsVisible={() => setIsFilter(undefined)} data={filters} onSelect={value => setFilter(value)} value={filter}/>
        </View>
    )
}

const getStyle = (theme: Theme) => 
    StyleSheet.create({
        filter: {
            flexDirection: 'row',
            alignItems: 'center',
            gap: theme.spacing.sm,
            paddingVertical: theme.spacing.xs * 2,
            paddingHorizontal: theme.spacing.md,
            borderWidth: 1,
            borderColor: theme.colors.lightGrey,
            borderRadius: theme.fontSize.jumbo
          },
    })